import React,{ Component } from "react";
import { Cell, Grid, CardTitle } from 'react-md';
import { SegmentedControl } from 'segmented-control';
import 'react-confirm-alert/src/react-confirm-alert.css';
import SecureShow from '../component/SecureShow';
import '../css/archive.css';
import '../css/Dashboard.css';
import CourseStudentEnrollmentList from './CourseStudentEnrollmentList'
import Sections from './sections'
import Courses from "./courses"

export default class CourseTabs extends Component {
    constructor(props){
        super(props);
        this.state = {
            showSection: false,
            showStudents: false,
        }
    }

    tabOnChange =(clickedValue) => {
        console.log('clicked value', clickedValue)
        if(clickedValue === 'Section'){
            this.setState({showSection: true,showStudents: false});
        }
        if(clickedValue === 'Students'){
            this.setState({showSection:false, showStudents: true});
        }
    }

    render(){
        return (
            <SecureShow targetRole={1}>
                <Grid gutter={1}>

                    <Cell size={10} >
                        <SegmentedControl 
                            name="Course_tabs"
                            style={{color: '#bb0000',
                                    zIndex:"1",
                                    marginTop:"-7px",
                                    marginLeft:"15px"}}
                            options ={[
                                { label: 'Sections', value:'Section', default:true },
                                { label: 'Students', value:'Students' }
                            ]}
                            setValue={value => this.tabOnChange(value)}
                        />
                    </Cell>
                    {
                        this.state.showSection?
                        <Cell size={12} className="gradebook-cell">   
                        <Sections {...this.props}/>
                        </Cell>
                        :
                        undefined
                    }
                    {
                        this.state.showStudents?
                        <Cell size={12} className="gradebook-cell">   
                        <CourseStudentEnrollmentList {...this.props}  />
                        </Cell>
                        :
                        undefined
                    }
                    
                </Grid>
            </SecureShow>
        )
    }
}